import {DataTransferObjectValidation} from "../../../type/Types";
import {ShoppingParticipationPolicyValueObject} from "../../vo/content/ShoppingParticipationPolicyValueObject";

export namespace ShoppingParticipationPolicyDataTransferObject {
    export type Post = {
        isDefaultValue: boolean | null,
        limitedFigure: number | null,
        firstFlagLocalTime: string | null,
        secondFlagLocalTime: string | null,
        allowedAmountMultiplier: number | null,
    }

    const timeRegex = /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/;

    export namespace Post {
        export const description: Record<keyof Post, string> = ShoppingParticipationPolicyValueObject.description

        export const validation: DataTransferObjectValidation<Post> = {
            isDefaultValue(o:string) : boolean | null | Error {
                if (o.length === 0) {
                    return null
                }
                try{
                    return o === 'true'
                } catch(e) {
                    return new Error('isDefaultValue', {cause: e})
                }

            },
            limitedFigure(o: string): number | null | Error {
                if (o.length === 0) {
                    return null
                }
                try {
                    return Number(o)
                } catch (e) {
                    return new Error('limitedFigure', { cause: e })
                }
            },
            firstFlagLocalTime(o:string) : string | null | Error {
                if(!timeRegex.test(o)){
                    return new Error("firstFlagLocalTime is not HH:mm:ss")
                }
                if (o.length === 0) {
                    return null
                }
                return o

            },
            secondFlagLocalTime(o:string) : string | null | Error  {
                if(!timeRegex.test(o)){
                    return new Error("secondFlagLocalTime is not HH:mm:ss")
                }
                if (o.length === 0) {
                    return null
                }
                return o

            },
            allowedAmountMultiplier(o: string): number | null | Error {
                if (o.length === 0) {
                    return null
                }
                try {
                    return Number(o)
                } catch (e) {
                    return new Error('allowedAmountMultiplier', { cause: e })
                }
            },
        }
    }

    export type Put = {
        isDefaultValue: boolean | null,
        limitedFigure: number | null,
        firstFlagLocalTime: string | null,
        secondFlagLocalTime: string | null,
        allowedAmountMultiplier: number | null,
    }

    export namespace Put {
        export const description: Record<keyof Post, string> = ShoppingParticipationPolicyValueObject.description

        export const validation: DataTransferObjectValidation<Post> = {
            isDefaultValue(o:string) : boolean | null | Error {
                if (o.length === 0) {
                    return null
                }
                try{
                    return o === 'true'
                } catch(e) {
                    return new Error('isDefaultValue', {cause: e})
                }

            },
            limitedFigure(o: string): number | null | Error {
                if (o.length === 0) {
                    return null
                }
                try {
                    return Number(o)
                } catch (e) {
                    return new Error('limitedFigure', { cause: e })
                }
            },
            firstFlagLocalTime(o:string) : string | null | Error {
                if(!timeRegex.test(o)){
                    return new Error("firstFlagLocalTime is not HH:mm:ss")
                }
                if (o.length === 0) {
                    return null
                }
                return o

            },
            secondFlagLocalTime(o:string) : string | null | Error {
                if(!timeRegex.test(o)){
                    return new Error("secondFlagLocalTime is not HH:mm:ss")
                }
                if (o.length === 0) {
                    return null
                }
                return o

            },
            allowedAmountMultiplier(o: string): number | null | Error {
                if (o.length === 0) {
                    return null
                }
                try {
                    return Number(o)
                } catch (e) {
                    return new Error('allowedAmountMultiplier', { cause: e })
                }
            },
        }
    }
}

